import { Directive } from '@angular/core';

// tslint:disable:directive-selector
@Directive({
    selector: 'igx-banner-actions'
})
export class IgxBannerActionsDirective {
}
